import { FC } from "react";
import { Container } from "../../../../components/Container";
import { Title } from "../../../../components/Title";
import styles from "./ForumProgram.module.sass";
import classNames from "classnames/dedupe";
import Hlibovytskyi from "../../../../assets/img/program/hlibovytskyi.png";
import Vynohradov from "../../../../assets/img/program/vynohradov.jpg";
import Ihnatiev from "../../../../assets/img/program/7.jpeg";
import Stretovych from "../../../../assets/img/program/stretovych.jpg";
import Minakov from "../../../../assets/img/program/minakov.jpg";
import Sudarkin from "../../../../assets/img/program/sudarkin.jpg";
import Havrysh from "../../../../assets/img/program/havrysh.jpg";
import Kostenko from "../../../../assets/img/program/kostenko.png";
import Klymov from "../../../../assets/img/program/klymov.webp";
import Dmytriiev from "../../../../assets/img/program/dmytriiev.jpg";
import Fedorov from "../../../../assets/img/program/fedorov.png";
import Frontier from "../../../../assets/img/speakers_logo/frontier.svg";
import Logo7 from "../../../../assets/img/speakers_logo/uabe.png";
import Nova from "../../../../assets/img/speakers_logo/np.svg";
import Anima from "../../../../assets/img/speakers_logo/anima.svg";
import MIM from "../../../../assets/img/speakers_logo/mm.svg";
import MIB from "../../../../assets/img/speakers_logo/mib.svg";
import Konsort from "../../../../assets/img/speakers_logo/konsort.svg";
import VodafoneBusiness from "../../../../assets/img/partners/vodafone.svg";

interface SpeakerProgramBlock {
  startAt: string;
  endAt: string;
  title: string;
  topic: string;
  img: string;
  logo: string;
  logoWidth: number;
  logoText?: string;
}

interface GeneralProgramBlock {
  startAt: string;
  endAt?: string;
  title: string;
}

const speakerProgramBlocks: SpeakerProgramBlock[] = [
  {
    startAt: "11:30",
    endAt: "12:00",
    title: "Євген Глібовицький",
    topic:
      "Спроможність як нова перемога: стратегія динамічного розвитку в умовах тривалої невизначеності",
    img: Hlibovytskyi,
    logo: Frontier,
    logoWidth: 93,
    logoText:
      "директор Інституту Фронтиру,\nчлен Наглядової ради\nСуспільного, викладач УКУ",
  },
  {
    startAt: "12:00",
    endAt: "12:20",
    title: "Андрій Федоров",
    topic:
      "Вижити сьогодні, створити майбутнє завтра: баланс, який рухає технології",
    img: Fedorov,
    logo: VodafoneBusiness,
    logoWidth: 102,
    logoText: "Директор департаменту бізнес ринку Vodafonе",
  },
  {
    startAt: "12:20",
    endAt: "12:50",
    title: "Олексій Виноградов",
    topic: "Як планувати маркетинг, коли правила змінюються щодня",
    img: Vynohradov,
    logo: MIM,
    logoWidth: 50,
    logoText: "віцепрезидент\nБізнес-школи МІМ",
  },
  {
    startAt: "12:50",
    endAt: "13:30",
    title: "Вячеслав Климов",
    topic: "Дискусія: Що означає розвивати бізнес в Україні сьогодні?",
    img: Klymov,
    logo: Nova,
    logoWidth: 110,
    logoText:
      "співзасновник групи компаній\nNOVA (Нова пошта), Президент\nСпілки українських підприємців.",
  },
  {
    startAt: "12:50",
    endAt: "13:30",
    title: "Віталій Дмитрієв",
    topic: "Дискусія: Що означає розвивати бізнес в Україні сьогодні?",
    img: Dmytriiev,
    logo: Konsort,
    logoWidth: 102,
    logoText: "власник, голова\nнаглядової ради",
  },
  {
    startAt: "14:30",
    endAt: "15:00",
    title: "Роман Гавриш",
    topic: "Конкурентна перевага після AI: чому brain capital вирішує все",
    img: Havrysh,
    logo: Anima,
    logoWidth: 95,
    logoText: "CEO та співзасновник Anima.ua\nВикладач у KMBS та LvBS.",
  },
  {
    startAt: "15:00",
    endAt: "15:30",
    title: "Станіслав Ігнатьєв",
    topic: "Нова енергетична реальність України: стратегії виживання бізнесу",
    img: Ihnatiev,
    logo: Logo7,
    logoWidth: 105,
    logoText: "Голова Ради Української асоціації\nвідновлюваної енергетики",
  },
  {
    startAt: "15:30",
    endAt: "16:00",
    title: "Олексій Мінаков",
    topic:
      'Впровадження ШІ: від "швидких перемог" до довгострокової стратегії. Практичне використання для керівника та команди',
    img: Minakov,
    logo: MIB,
    logoWidth: 62,
    logoText: "викладач в Міжнародному\nІнституті Бізнесу",
  },
  {
    startAt: "16:00",
    endAt: "16:30",
    title: "Алла Костенко",
    topic:
      "Секрет ефективної команди: як за домогою людей підвищувати ефективність бізнесу і зростати",
    img: Kostenko,
    logo: Konsort,
    logoWidth: 102,
    logoText:
      'CEO Асоціації KONSORT\nспіввласниця Центру вивчення\nіноземних мов "Speak it"',
  },
  {
    startAt: "16:30",
    endAt: "17:00",
    title: "Богдан Стретович",
    topic:
      "Підтримка клієнта як продукт. Контакт-центр як сенсорна система зростання.",
    img: Stretovych,
    logo: Nova,
    logoWidth: 110,
    logoText:
      "директор департаменту\nНаціонального контакт-центру\nНової пошти",
  },
  {
    startAt: "17:00",
    endAt: "17:30",
    title: "Олександр Сударкін",
    topic: "Як змінювати компанію, коли бракує людей, часу й ресурсу",
    img: Sudarkin,
    logo: MIM,
    logoWidth: 50,
    logoText: "директор програми\nМВА бізнес-школи МІМ",
  },
];

const generalProgramBlocks: GeneralProgramBlock[] = [
  {
    startAt: "11:00",
    endAt: "11:30",
    title: "Вступні слова та звернення партнерів",
  },
  {
    startAt: "13:30",
    endAt: "14:30",
    title: "Обід та нетворкінг",
  },
  {
    startAt: "17:30",
    title: "Вечірній нетворкінг під DJ-сет",
  },
];

export const ForumProgram: FC = () => {
  const ProgramNode: FC<SpeakerProgramBlock> = (program) => (
    <div data-aos="zoom-out" className={styles.row}>
      <div className={classNames("df-center fd-column", styles.head)}>
        {program.logo && (
          <img
            alt="logo"
            style={{ width: program.logoWidth }}
            src={program.logo}
          />
        )}
        {program.logoText && (
          <p className={styles.logoText}>{program.logoText}</p>
        )}
      </div>
      <div className={styles.content}>
        <div className={classNames("df-center fd-column", styles.wrapper)}>
          <div className={classNames("df-center", styles.titleBlock)}>
            <div className={styles.timeTag}>
              {program.startAt}-{program.endAt}
            </div>
            <h3 className={styles.title}>{program.title}</h3>
            {program.title === "Роман Гавриш" && (
              <div className={styles.onlineTag}>ON-LINE</div>
            )}
          </div>
          {program.topic && <hr className={styles.lightLine} />}
          {program.topic && <h4 className={styles.topic}>{program.topic}</h4>}
        </div>
        {program?.img && (
          <div className={styles.imgWrapper}>
            <img src={program.img} alt={`Speaker: ${program.title}`} />
          </div>
        )}
      </div>
    </div>
  );

  const SubProgramNode: FC<GeneralProgramBlock> = (program) => (
    <div data-aos="zoom-out" className={classNames("df-center", styles.row2)}>
      <div className={styles.timeTag}>
        {program.startAt}
        {program.endAt && `-${program.endAt}`}
      </div>
      <h3 className={styles.title}>{program.title}</h3>
    </div>
  );

  return (
    <Container className={classNames("df-center fd-column", styles.root)}>
      <Title text="Програма форуму" />
      <div className={classNames("fd-column", styles.container)}>
        <SubProgramNode {...generalProgramBlocks[0]} />

        {speakerProgramBlocks.slice(0, 5).map((program) => (
          <ProgramNode key={program.topic} {...program} />
        ))}

        <SubProgramNode {...generalProgramBlocks[1]} />

        {speakerProgramBlocks.slice(5).map((program) => (
          <ProgramNode key={program.topic} {...program} />
        ))}

        <SubProgramNode {...generalProgramBlocks[2]} />
      </div>
    </Container>
  );
};
